export default __webpack_public_path__ + "static/media/autoconsumo-compartido.7a42296b.png";